/**
 * @param value
 * @return {boolean}
 */
const isControlled = (value) => value !== undefined && value !== null;

// eslint-disable-next-line import/prefer-default-export
export { isControlled };
